import styled, { css } from "styled-components";

export const ModalFormWrapper = styled.div<{ padding?: string; width?: string; height?: string }>`
   padding: 60px 50px;

   ${({ width }) => css`
      width: ${width};
   `}

   @media screen and (max-width: 768px) {
      width: 100%;
   }

   &.noPadding {
      padding: 0;
   }

   .title {
      font-weight: 500;
      font-size: 22px;
      line-height: 28px;
      color: #444444;
      text-align: center;
      margin-bottom: 1.1rem;
   }
   .description {
      font-size: 16x;
      line-height: 23px;
      text-align: center;
      color: #666666;
      margin-bottom: 3rem;
   }
   .form-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 23px;
      text-align: center;
      color: #666666;
      margin-bottom: 3.6rem;
   }
   .stack {
      display: flex;
      height: 23rem;
      flex-direction: column;
      justify-content: space-between;
      &.small {
         height: 15rem;
      }
   }
   .btn-div {
      margin-top: 3.7rem;
      display: flex;
      justify-content: end;
      &.space-between {
         justify-content: space-between;
      }
   }
   .flex-center {
      display: flex;
      align-items: center;
   }

   .form-preview-heading {
      background-color: ${({ theme }) => theme.colors?.primary};
      position: relative
      min-height: 127px;
      padding: 20px 34px;
      font-size: 14px;
      color: #fff;

      .form-first-box{
         position: absolute;
         background-color: rgba(0,0,0,0.5);
         top: 27px;
         right: 42px;
         width: 46px;
         height: 56px
      }

      .form-second-box{
         position: absolute;
         background-color: rgba(0,0,0,0.1);
         top: 54px;
         right: 88px;
         width: 46px;
         height: 56px
      }

   }

   .form-preview {
      padding: 28px 36px 106px 34px;

      .form-data {
         display: flex;
         justify-content: space-between;
         margin-bottom: 10px;

         span.title {
            color: #444;
            font-size: 16px;
         }
      }

      span {
         font-size: 14px;
         color: #666;
      }
   }

    div.hr {
         border: 0.25px dashed #BEBCBC;
   }

   .form-total-data {
      display: flex;
      justify-content: space-between;
      padding: 33px 36px 0 34px;
       span {
         font-size: 14px;
         color: #666;
      }
   }
`;
